import React from 'react';
import './About.css';

const About = () => {
    return (
     <div className="about">
            <div className="inside">
            <h1> Why Choose <span className="head">Dental Hospital</span></h1>
                <p>
                
                    We Provide Best Exprience Doctor and Set The Good Environment for Patient..we are give service always without big free. we are always try our best service for our patient. We are arrange 2 times parent day in a one year.... and two time eid purnomiloni. We are Provided lunch Every Day with out coast. This make us difference.
                    We Provide Best Exprience Doctor and Set The Good Environment for Patient..we are give service always without big free. we are always try our best service for our patient. We are arrange 2 times parent day in a one year.... and two time eid purnomiloni. We are Provided lunch Every Day with out coast. This make us difference.

                    
                  
                    
                </p>
            <button type="button" class="btn btn-warning">Read More</button>
            
            </div>
            
     </div>
     
    );
};

export default About;